import { render, staticRenderFns } from "./BaseTagItem.vue?vue&type=template&id=2a918824&scoped=true&"
import script from "./BaseTagItem.vue?vue&type=script&lang=js&"
export * from "./BaseTagItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseTagItem.vue?vue&type=style&index=0&id=2a918824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a918824",
  null
  
)

export default component.exports